import { render, staticRenderFns } from "./ChooseGoodsAddress.vue?vue&type=template&id=f74f7326&scoped=true&"
import script from "./ChooseGoodsAddress.vue?vue&type=script&lang=js&"
export * from "./ChooseGoodsAddress.vue?vue&type=script&lang=js&"
import style0 from "./ChooseGoodsAddress.vue?vue&type=style&index=0&id=f74f7326&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f74f7326",
  null
  
)

export default component.exports